export const tools = [
    {
        name: 'platform_Admins_list',
        description: 'Platform-staff users of the control-plane pool.',
        context: 'platform',
        operationId: 'Admins_list',
        method: 'GET',
        path: '/admins',
        action: 'admin:list',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                query: {
                    type: 'object',
                    properties: {
                        cursor: {
                            type: 'string',
                        },
                        limit: {
                            type: 'integer',
                            format: 'int32',
                            minimum: 1,
                            maximum: 200,
                            default: 50,
                        },
                    },
                    required: [],
                    additionalProperties: false,
                },
            },
            required: [],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Admins_create',
        description: 'Invite a platform-staff user: creates them in the control-plane pool (TOTP required at first sign-in).',
        context: 'platform',
        operationId: 'Admins_create',
        method: 'POST',
        path: '/admins',
        action: 'admin:create',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                body: {
                    type: 'object',
                    required: ['email'],
                    properties: {
                        email: {
                            type: 'string',
                        },
                        name: {
                            type: 'string',
                        },
                    },
                },
            },
            required: ['body'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Admins_remove',
        description: 'Remove a platform-staff user. Never oneself.',
        context: 'platform',
        operationId: 'Admins_remove',
        method: 'DELETE',
        path: '/admins/{sub}',
        action: 'admin:remove',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        sub: {
                            type: 'string',
                            minLength: 1,
                            maxLength: 128,
                            description: "Cognito subject (the identity's stable id).",
                        },
                    },
                    required: ['sub'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Admins_get',
        description: 'One platform-staff user.',
        context: 'platform',
        operationId: 'Admins_get',
        method: 'GET',
        path: '/admins/{sub}',
        action: 'admin:read',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        sub: {
                            type: 'string',
                            minLength: 1,
                            maxLength: 128,
                            description: "Cognito subject (the identity's stable id).",
                        },
                    },
                    required: ['sub'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Announcements_list',
        description: 'Announcements, newest first.',
        context: 'platform',
        operationId: 'Announcements_list',
        method: 'GET',
        path: '/announcements',
        action: 'announcement:list',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                query: {
                    type: 'object',
                    properties: {
                        cursor: {
                            type: 'string',
                        },
                        limit: {
                            type: 'integer',
                            format: 'int32',
                            minimum: 1,
                            maximum: 200,
                            default: 50,
                        },
                    },
                    required: [],
                    additionalProperties: false,
                },
            },
            required: [],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Announcements_publish',
        description: "Show a notice to the people of a tenant, one person, or every active tenant of a cell. Sent\nto each tenant's cell; audited on each tenant's log.",
        context: 'platform',
        operationId: 'Announcements_publish',
        method: 'POST',
        path: '/announcements',
        action: 'announcement:publish',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                body: {
                    type: 'object',
                    required: ['target', 'severity', 'title', 'body'],
                    properties: {
                        target: {
                            type: 'object',
                            properties: {
                                tenantId: {
                                    type: 'string',
                                    pattern: '^[a-z0-9][a-z0-9-]{1,62}$',
                                    description: 'One tenant. Exactly one of `tenantId` and `cellId`.',
                                },
                                sub: {
                                    type: 'string',
                                    minLength: 1,
                                    maxLength: 128,
                                    description: 'One person of that tenant (their `sub`). Only with `tenantId`.',
                                },
                                cellId: {
                                    type: 'string',
                                    description: 'Every active tenant of this cell.',
                                },
                            },
                            description: 'Where an announcement goes: one tenant (optionally one person in it), or every active tenant of one cell.',
                        },
                        severity: {
                            type: 'string',
                            enum: ['info', 'important', 'security'],
                            description: 'How much a notice asks of the person. `info` and `important` can be dismissed; a `security`\nnotice stays on screen until the person says they have read it.',
                        },
                        title: {
                            type: 'string',
                            minLength: 1,
                            maxLength: 120,
                        },
                        body: {
                            type: 'string',
                            minLength: 1,
                            maxLength: 2000,
                        },
                        link: {
                            type: 'object',
                            required: ['label', 'url'],
                            properties: {
                                label: {
                                    type: 'string',
                                    minLength: 1,
                                    maxLength: 60,
                                },
                                url: {
                                    type: 'string',
                                    maxLength: 2000,
                                    pattern: '^https://[^\\s]+$',
                                },
                            },
                            description: 'An optional link in a notice, to the page that says more. https only.',
                        },
                        expiresAt: {
                            type: 'string',
                            format: 'date-time',
                            description: 'The apps stop showing it at this time. Absent: until withdrawn.',
                        },
                    },
                    description: 'What staff say to the people of a tenant or cell (ADR in-app-notices-from-staff).',
                },
            },
            required: ['body'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Announcements_withdraw',
        description: 'Take an announcement back: the apps stop showing it. Idempotent.',
        context: 'platform',
        operationId: 'Announcements_withdraw',
        method: 'POST',
        path: '/announcements/{announcementId}/withdraw',
        action: 'announcement:withdraw',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        announcementId: {
                            type: 'string',
                            pattern: '^n_[A-Za-z0-9]{12,40}$',
                            description: 'A notice staff published (ADR in-app-notices-from-staff): `n_` and a random token.',
                        },
                    },
                    required: ['announcementId'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Cells_list',
        description: 'Every cell the directory routes to, with hostnames and tenant counts.',
        context: 'platform',
        operationId: 'Cells_list',
        method: 'GET',
        path: '/cells',
        action: 'cell:list',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {},
            required: [],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Menu_get',
        description: 'The platform menu definition: every item with the action and feature that gate it.',
        context: 'platform',
        operationId: 'Menu_get',
        method: 'GET',
        path: '/menu',
        action: 'menu:read',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {},
            required: [],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Metering_ingest',
        description: 'Ingest usage records for a tenant (stub: stored, not yet aggregated). Cells use the bus.',
        context: 'platform',
        operationId: 'Metering_ingest',
        method: 'POST',
        path: '/metering',
        action: 'metering:ingest',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                body: {
                    type: 'object',
                    required: ['tenantId', 'cellId', 'events'],
                    properties: {
                        tenantId: {
                            type: 'string',
                            pattern: '^[a-z0-9][a-z0-9-]{1,62}$',
                            description: "Tenant identifier. The control plane's own resources use the literal `platform`.",
                        },
                        cellId: {
                            type: 'string',
                        },
                        events: {
                            type: 'array',
                            items: {
                                type: 'object',
                                required: ['metric', 'quantity', 'unit', 'periodStart', 'periodEnd', 'dimensions'],
                                properties: {
                                    metric: {
                                        type: 'string',
                                        pattern: '^[a-z][a-z0-9-]*(\\.[a-z][a-z0-9-]*)+$',
                                        description: 'Dotted metric, e.g. `api.requests`, `email.sent`.',
                                    },
                                    quantity: {
                                        type: 'number',
                                        format: 'double',
                                        minimum: 0,
                                    },
                                    unit: {
                                        type: 'string',
                                    },
                                    periodStart: {
                                        type: 'string',
                                        format: 'date-time',
                                    },
                                    periodEnd: {
                                        type: 'string',
                                        format: 'date-time',
                                    },
                                    dimensions: {
                                        type: 'object',
                                        additionalProperties: {
                                            type: 'string',
                                        },
                                    },
                                },
                                description: 'A usage record (SBT meteringEvent shape) — see `platform.metering.recorded`.',
                            },
                        },
                    },
                },
            },
            required: ['body'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Metering_usage',
        description: 'Usage per tenant over one UTC month or day, summed per metric; `tenantId` narrows it to one tenant.',
        context: 'platform',
        operationId: 'Metering_usage',
        method: 'GET',
        path: '/metering/usage',
        action: 'metering:read',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                query: {
                    type: 'object',
                    properties: {
                        cursor: {
                            type: 'string',
                        },
                        limit: {
                            type: 'integer',
                            format: 'int32',
                            minimum: 1,
                            maximum: 200,
                            default: 50,
                        },
                        period: {
                            type: 'string',
                            pattern: '^[0-9]{4}-[0-9]{2}(-[0-9]{2})?$',
                            description: 'A UTC calendar month (`YYYY-MM`) or a UTC day (`YYYY-MM-DD`).',
                        },
                        tenantId: {
                            type: 'string',
                            pattern: '^[a-z0-9][a-z0-9-]{1,62}$',
                            description: "Tenant identifier. The control plane's own resources use the literal `platform`.",
                        },
                    },
                    required: ['period'],
                    additionalProperties: false,
                },
            },
            required: ['query'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Packages_list',
        description: 'List catalog packages, retired ones included when asked.',
        context: 'platform',
        operationId: 'Packages_list',
        method: 'GET',
        path: '/packages',
        action: 'package:list',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                query: {
                    type: 'object',
                    properties: {
                        cursor: {
                            type: 'string',
                        },
                        limit: {
                            type: 'integer',
                            format: 'int32',
                            minimum: 1,
                            maximum: 200,
                            default: 50,
                        },
                        includeRetired: {
                            type: 'boolean',
                        },
                    },
                    required: [],
                    additionalProperties: false,
                },
            },
            required: [],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Packages_create',
        description: 'Create a package at version 1.',
        context: 'platform',
        operationId: 'Packages_create',
        method: 'POST',
        path: '/packages',
        action: 'package:create',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                body: {
                    type: 'object',
                    required: ['packageId', 'product', 'name', 'tiers', 'features', 'stripePriceId'],
                    properties: {
                        packageId: {
                            type: 'string',
                            pattern: '^pkg_[a-z0-9-]+$',
                            description: 'Package identifier (`pkg_...`).',
                        },
                        product: {
                            type: 'string',
                            pattern: '^[a-z][a-z0-9-]*$',
                            description: 'A known product; `tiers` must be tiers it sells. Cannot be changed later.',
                        },
                        name: {
                            type: 'string',
                        },
                        tiers: {
                            type: 'array',
                            items: {
                                type: 'string',
                                enum: ['pool', 'silo'],
                                description: 'Isolation tier of a tenant (SaaS Lens: pool = shared cell, silo = dedicated cell).',
                            },
                        },
                        features: {
                            type: 'array',
                            items: {
                                type: 'string',
                                pattern: '^[a-z][a-z0-9-]*(\\.[a-z][a-z0-9-]*)*$',
                                description: 'A feature flag a package grants. Closed list, extended by contract change only.',
                            },
                        },
                        stripePriceId: {
                            type: 'string',
                            pattern: '^price_[A-Za-z0-9]+$',
                            description: 'Stripe price identifier (`price_...`).',
                        },
                        billingModel: {
                            type: 'string',
                            enum: ['perSeat', 'flat'],
                            description: 'Default `perSeat`.',
                        },
                        assistant: {
                            type: 'object',
                            required: ['models', 'monthlyLimitMicroUsd'],
                            properties: {
                                models: {
                                    type: 'array',
                                    items: {
                                        type: 'string',
                                        enum: ['fast', 'standard'],
                                        description: 'A kind of AI model a package may use, named by purpose, never by vendor (the assistant context\nmaps it). `standard` is the ceiling (owner ruling 2026-11-03).',
                                    },
                                    minItems: 1,
                                    description: 'Model classes the tenant may use.',
                                },
                                monthlyLimitMicroUsd: {
                                    type: 'integer',
                                    format: 'int64',
                                    minimum: 0,
                                    description: 'Hard stop for the whole tenant per calendar month.',
                                },
                                dailyLimitMicroUsd: {
                                    type: 'integer',
                                    format: 'int64',
                                    minimum: 0,
                                    description: 'Hard stop for the whole tenant per day. Absent: only the monthly limit.',
                                },
                                memberMonthlyLimitMicroUsd: {
                                    type: 'integer',
                                    format: 'int64',
                                    minimum: 0,
                                    description: 'Hard stop for one person per calendar month. Absent: no per-person limit.',
                                },
                            },
                            description: 'Absent: no assistant.',
                        },
                    },
                },
            },
            required: ['body'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Packages_get',
        description: 'Read a package at its current version.',
        context: 'platform',
        operationId: 'Packages_get',
        method: 'GET',
        path: '/packages/{packageId}',
        action: 'package:read',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        packageId: {
                            type: 'string',
                            pattern: '^pkg_[a-z0-9-]+$',
                            description: 'Package identifier (`pkg_...`).',
                        },
                    },
                    required: ['packageId'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Packages_update',
        description: 'Edit a package. Bumps `version`; no tenant snapshot changes.',
        context: 'platform',
        operationId: 'Packages_update',
        method: 'PATCH',
        path: '/packages/{packageId}',
        action: 'package:update',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        packageId: {
                            type: 'string',
                            pattern: '^pkg_[a-z0-9-]+$',
                            description: 'Package identifier (`pkg_...`).',
                        },
                    },
                    required: ['packageId'],
                    additionalProperties: false,
                },
                body: {
                    type: 'object',
                    properties: {
                        name: {
                            type: 'string',
                        },
                        tiers: {
                            type: 'array',
                            items: {
                                type: 'string',
                                enum: ['pool', 'silo'],
                                description: 'Isolation tier of a tenant (SaaS Lens: pool = shared cell, silo = dedicated cell).',
                            },
                        },
                        features: {
                            type: 'array',
                            items: {
                                type: 'string',
                                pattern: '^[a-z][a-z0-9-]*(\\.[a-z][a-z0-9-]*)*$',
                                description: 'A feature flag a package grants. Closed list, extended by contract change only.',
                            },
                        },
                        stripePriceId: {
                            type: 'string',
                            pattern: '^price_[A-Za-z0-9]+$',
                            description: 'Stripe price identifier (`price_...`).',
                        },
                        billingModel: {
                            type: 'string',
                            enum: ['perSeat', 'flat'],
                            description: 'How billing charges a package: per seat (quantity follows memberships) or one flat price.',
                        },
                        assistant: {
                            anyOf: [
                                {
                                    type: 'object',
                                    required: ['models', 'monthlyLimitMicroUsd'],
                                    properties: {
                                        models: {
                                            type: 'array',
                                            items: {
                                                type: 'string',
                                                enum: ['fast', 'standard'],
                                                description: 'A kind of AI model a package may use, named by purpose, never by vendor (the assistant context\nmaps it). `standard` is the ceiling (owner ruling 2026-11-03).',
                                            },
                                            minItems: 1,
                                            description: 'Model classes the tenant may use.',
                                        },
                                        monthlyLimitMicroUsd: {
                                            type: 'integer',
                                            format: 'int64',
                                            minimum: 0,
                                            description: 'Hard stop for the whole tenant per calendar month.',
                                        },
                                        dailyLimitMicroUsd: {
                                            type: 'integer',
                                            format: 'int64',
                                            minimum: 0,
                                            description: 'Hard stop for the whole tenant per day. Absent: only the monthly limit.',
                                        },
                                        memberMonthlyLimitMicroUsd: {
                                            type: 'integer',
                                            format: 'int64',
                                            minimum: 0,
                                            description: 'Hard stop for one person per calendar month. Absent: no per-person limit.',
                                        },
                                    },
                                    description: 'What a package allows of the assistant (AI model calls), per tenant (#16). The cell checks\nevery limit BEFORE a call: a call that could cross one is refused and costs nothing. Callers are\nwarned from 80% of a limit (design standard DS-COST-02). Money in millionths of a US dollar;\nperiods are UTC calendar months and days.',
                                },
                                {
                                    type: 'null',
                                },
                            ],
                            description: '`null` takes the assistant out of the package.',
                        },
                    },
                    description: 'Any change bumps `version`. `packageId`, `product` and `version` are not editable.',
                },
            },
            required: ['params', 'body'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Packages_retire',
        description: 'Retire a package: no new adoptions. Existing snapshots are untouched.',
        context: 'platform',
        operationId: 'Packages_retire',
        method: 'POST',
        path: '/packages/{packageId}/retire',
        action: 'package:retire',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        packageId: {
                            type: 'string',
                            pattern: '^pkg_[a-z0-9-]+$',
                            description: 'Package identifier (`pkg_...`).',
                        },
                    },
                    required: ['packageId'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Products_list',
        description: 'Every product the platform sells, one per `products/<name>/product.yaml`.',
        context: 'platform',
        operationId: 'Products_list',
        method: 'GET',
        path: '/products',
        action: 'product:list',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {},
            required: [],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Tenants_list',
        description: 'List tenants in the registry.',
        context: 'platform',
        operationId: 'Tenants_list',
        method: 'GET',
        path: '/tenants',
        action: 'tenant:list',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                query: {
                    type: 'object',
                    properties: {
                        cursor: {
                            type: 'string',
                        },
                        limit: {
                            type: 'integer',
                            format: 'int32',
                            minimum: 1,
                            maximum: 200,
                            default: 50,
                        },
                        status: {
                            type: 'string',
                            enum: [
                                'pendingPayment',
                                'provisioning',
                                'locked',
                                'active',
                                'suspended',
                                'offboarding',
                                'deprovisioned',
                                'failed',
                            ],
                            description: 'Lifecycle of a tenant in the registry.',
                        },
                    },
                    required: [],
                    additionalProperties: false,
                },
            },
            required: [],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Tenants_create',
        description: 'Onboard a tenant (sales-led). Starts the onboarding workflow; returns 202 with the registry entry in `pendingPayment`.',
        context: 'platform',
        operationId: 'Tenants_create',
        method: 'POST',
        path: '/tenants',
        action: 'tenant:create',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                body: {
                    type: 'object',
                    required: ['slug', 'name', 'adminEmail', 'tier', 'packageId'],
                    properties: {
                        slug: {
                            type: 'string',
                            pattern: '^[a-z][a-z0-9-]{2,39}$',
                            description: 'URL-safe workspace slug chosen at signup or by the operator.',
                        },
                        name: {
                            type: 'string',
                        },
                        adminEmail: {
                            type: 'string',
                        },
                        tier: {
                            type: 'string',
                            enum: ['pool', 'silo'],
                            description: 'Isolation tier of a tenant (SaaS Lens: pool = shared cell, silo = dedicated cell).',
                        },
                        packageId: {
                            type: 'string',
                            pattern: '^pkg_[a-z0-9-]+$',
                            description: "Package to snapshot at provisioning. Must allow `tier`; its product becomes the tenant's.",
                        },
                    },
                    description: 'What the operator supplies to onboard a tenant (sales-led). Self-serve uses `/signup`.',
                },
            },
            required: ['body'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Tenants_get',
        description: 'Read one tenant registry entry, including its entitlement snapshot.',
        context: 'platform',
        operationId: 'Tenants_get',
        method: 'GET',
        path: '/tenants/{tenantId}',
        action: 'tenant:read',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        tenantId: {
                            type: 'string',
                            pattern: '^[a-z0-9][a-z0-9-]{1,62}$',
                            description: "Tenant identifier. The control plane's own resources use the literal `platform`.",
                        },
                    },
                    required: ['tenantId'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Tenants_update',
        description: 'Update name or flags. Tier, package and status have their own operations.',
        context: 'platform',
        operationId: 'Tenants_update',
        method: 'PATCH',
        path: '/tenants/{tenantId}',
        action: 'tenant:update',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        tenantId: {
                            type: 'string',
                            pattern: '^[a-z0-9][a-z0-9-]{1,62}$',
                            description: "Tenant identifier. The control plane's own resources use the literal `platform`.",
                        },
                    },
                    required: ['tenantId'],
                    additionalProperties: false,
                },
                body: {
                    type: 'object',
                    properties: {
                        name: {
                            type: 'string',
                        },
                        flags: {
                            type: 'object',
                            additionalProperties: {
                                type: 'boolean',
                            },
                        },
                    },
                },
            },
            required: ['params', 'body'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Tenants_offboard',
        description: 'Start offboarding. Data is retained per the retention policy until deprovisioning completes.',
        context: 'platform',
        operationId: 'Tenants_offboard',
        method: 'POST',
        path: '/tenants/{tenantId}/offboard',
        action: 'tenant:offboard',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        tenantId: {
                            type: 'string',
                            pattern: '^[a-z0-9][a-z0-9-]{1,62}$',
                            description: "Tenant identifier. The control plane's own resources use the literal `platform`.",
                        },
                    },
                    required: ['tenantId'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Tenants_onboarding',
        description: "The onboarding workflow's state for a tenant: stage, attempt, execution, checkout, failure.",
        context: 'platform',
        operationId: 'Tenants_onboarding',
        method: 'GET',
        path: '/tenants/{tenantId}/onboarding',
        action: 'tenant:read',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        tenantId: {
                            type: 'string',
                            pattern: '^[a-z0-9][a-z0-9-]{1,62}$',
                            description: "Tenant identifier. The control plane's own resources use the literal `platform`.",
                        },
                    },
                    required: ['tenantId'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Tenants_adoptPackage',
        description: "Adopt a package: snapshots the package's current version onto the tenant.",
        context: 'platform',
        operationId: 'Tenants_adoptPackage',
        method: 'POST',
        path: '/tenants/{tenantId}/package',
        action: 'tenant:adopt-package',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        tenantId: {
                            type: 'string',
                            pattern: '^[a-z0-9][a-z0-9-]{1,62}$',
                            description: "Tenant identifier. The control plane's own resources use the literal `platform`.",
                        },
                    },
                    required: ['tenantId'],
                    additionalProperties: false,
                },
                body: {
                    type: 'object',
                    required: ['packageId'],
                    properties: {
                        packageId: {
                            type: 'string',
                            pattern: '^pkg_[a-z0-9-]+$',
                            description: 'Package identifier (`pkg_...`).',
                        },
                    },
                },
            },
            required: ['params', 'body'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Tenants_reapplyPackage',
        description: "Re-apply the tenant's package: replaces the snapshot with the package's current version.\nThe only way a catalog edit reaches a tenant. Explicit, audited, never implicit.",
        context: 'platform',
        operationId: 'Tenants_reapplyPackage',
        method: 'POST',
        path: '/tenants/{tenantId}/package/reapply',
        action: 'tenant:reapply-package',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        tenantId: {
                            type: 'string',
                            pattern: '^[a-z0-9][a-z0-9-]{1,62}$',
                            description: "Tenant identifier. The control plane's own resources use the literal `platform`.",
                        },
                    },
                    required: ['tenantId'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Tenants_resume',
        description: 'Lift a suspension.',
        context: 'platform',
        operationId: 'Tenants_resume',
        method: 'POST',
        path: '/tenants/{tenantId}/resume',
        action: 'tenant:resume',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        tenantId: {
                            type: 'string',
                            pattern: '^[a-z0-9][a-z0-9-]{1,62}$',
                            description: "Tenant identifier. The control plane's own resources use the literal `platform`.",
                        },
                    },
                    required: ['tenantId'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Tenants_retry',
        description: 'Retry a failed onboarding: starts a new workflow attempt. 409 unless the tenant is `failed`.',
        context: 'platform',
        operationId: 'Tenants_retry',
        method: 'POST',
        path: '/tenants/{tenantId}/retry',
        action: 'tenant:retry',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        tenantId: {
                            type: 'string',
                            pattern: '^[a-z0-9][a-z0-9-]{1,62}$',
                            description: "Tenant identifier. The control plane's own resources use the literal `platform`.",
                        },
                    },
                    required: ['tenantId'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Tenants_suspend',
        description: 'Suspend sign-in for every user of the tenant. Data is untouched.',
        context: 'platform',
        operationId: 'Tenants_suspend',
        method: 'POST',
        path: '/tenants/{tenantId}/suspend',
        action: 'tenant:suspend',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        tenantId: {
                            type: 'string',
                            pattern: '^[a-z0-9][a-z0-9-]{1,62}$',
                            description: "Tenant identifier. The control plane's own resources use the literal `platform`.",
                        },
                    },
                    required: ['tenantId'],
                    additionalProperties: false,
                },
            },
            required: ['params'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Tenants_changeTier',
        description: "Change the tenant's tier. Moving to silo starts a cell provisioning job; returns 202.",
        context: 'platform',
        operationId: 'Tenants_changeTier',
        method: 'POST',
        path: '/tenants/{tenantId}/tier',
        action: 'tenant:change-tier',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {
                params: {
                    type: 'object',
                    properties: {
                        tenantId: {
                            type: 'string',
                            pattern: '^[a-z0-9][a-z0-9-]{1,62}$',
                            description: "Tenant identifier. The control plane's own resources use the literal `platform`.",
                        },
                    },
                    required: ['tenantId'],
                    additionalProperties: false,
                },
                body: {
                    type: 'object',
                    required: ['tier'],
                    properties: {
                        tier: {
                            type: 'string',
                            enum: ['pool', 'silo'],
                            description: 'Isolation tier of a tenant (SaaS Lens: pool = shared cell, silo = dedicated cell).',
                        },
                        cellId: {
                            type: 'string',
                            description: 'Silo tier needs a cell to move to; the workflow vends it when absent.',
                        },
                    },
                },
            },
            required: ['params', 'body'],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Tiers_list',
        description: 'The tiers this cell offers and their limits.',
        context: 'platform',
        operationId: 'Tiers_list',
        method: 'GET',
        path: '/tiers',
        action: 'tier:list',
        auth: 'platform-admin',
        inputSchema: {
            type: 'object',
            properties: {},
            required: [],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Workspaces_get',
        description: "The caller's own workspace: name, tier, status, entitlement.",
        context: 'platform',
        operationId: 'Workspaces_get',
        method: 'GET',
        path: '/workspace',
        action: 'workspace:read',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {},
            required: [],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Workspaces_catalog',
        description: "Packages the caller's tenant could adopt (its tier, not retired).",
        context: 'platform',
        operationId: 'Workspaces_catalog',
        method: 'GET',
        path: '/workspace/catalog',
        action: 'catalog:read',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {},
            required: [],
            additionalProperties: false,
        },
    },
    {
        name: 'platform_Workspaces_entitlement',
        description: "The caller's entitlement snapshot. What the app gates features on.",
        context: 'platform',
        operationId: 'Workspaces_entitlement',
        method: 'GET',
        path: '/workspace/entitlement',
        action: 'entitlement:read',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {},
            required: [],
            additionalProperties: false,
        },
    },
];
//# sourceMappingURL=tools.js.map